export default "__VITE_ASSET__BfuyE4gq__"